import {Button, Table, Typography, Form, Space, Row} from "antd";
import React, {SetStateAction, useEffect, useState} from "react";
import {EditableCell, EditableRow} from "./EditTable";

import {ColumnTypes} from "types/models/column-table-edit";
import "./TableInputAdd.scss";

const TableInputAdd = ({
  data,
  column,
  setData,
  isCheckbox,
  disabled,
  ...rest
}): JSX.Element => {
  const addRowTb1 = () => {
    const newData = {
      // key: data.length + 1,
      ...column.reduce((obj, col) => {
        if (col.dataIndex !== "stt" && obj) {
          if (col.selected) {
            obj[col.placeholder] = "Chọn";
          } else {
            obj[col.placeholder] = "Nhập";
          }
        }
      }, {}),
    };

    setData([...data, newData]);
  };

  column.some(item => {
    // if (item.key == "action") {
    //   item.title = (
    //     <Button
    //       disabled={disabled}
    //       type="primary"
    //       onClick={addRowTb1}
    //       icon={<Icons.add rev={0} />}
    //     />
    //   );
    //   item.render = (_, record: {id: number}, index) => (
    //     <Button
    //       disabled={disabled}
    //       type="primary"
    //       danger
    //       onClick={() => removeRowTb1(index)}
    //       icon={<Icons.sub rev={0} />}
    //     />
    //   );
    // }
  });

  const removeRowTb1 = indexRemove => {
    const newData = data.filter((e, index) => index != indexRemove);
    setData([...newData]);
  };

  const handleSave = (row, index) => {
    const newData = [...data];

    newData[index] = {...newData[index], ...row};
    setData(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const columns = column
    .filter(e => e.show == true)
    .map(col => {
      return {
        ...col,
        onCell: (record, index) => ({
          record: data[index],
          selected: col.selected,
          dataIndex: col.dataIndex,
          title: col.title,
          options: col.options,
          onChange: col.onChange,
          index: index,
          handleSave,
          type: col.type,
          disabled: disabled ?? col.disabled,
          value: col.value,
          name: col.name,
          rules: col.rules,
          autoFocus: col.autoFocus,
          // ...col,
        }),
      };
    });

  return (
    <>
      <Table
        className="table-prescription"
        {...rest}
        components={components}
        rowClassName={"editable-row-2"}
        bordered
        dataSource={data}
        columns={columns as ColumnTypes}
        pagination={false}
      />
    </>
  );
};

export default TableInputAdd;
